import React, { useContext, useEffect } from 'react';

import 'react-toastify/dist/ReactToastify.css';

import isPropValid from '@emotion/is-prop-valid';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { StyleSheetManager } from 'styled-components';

import ICardio from './components';
import {
  useGetKeypointCollectionClassesQuery,
  useGetPhaseClassesQuery,
  useGetSegmentationClassesQuery,
  useGetViewClassesQuery,
} from './redux/slices/icardio';
import { ClassDataContext } from './services/contexts';
import {
  IClassData,
  IKeypointClass,
  IPhaseClass,
  ISegmentationClass,
  IViewClass,
} from './models/icardio';

function App() {
  const { data: viewClasses } = useGetViewClassesQuery();
  const { data: phaseClasses } = useGetPhaseClassesQuery();
  const { data: keyPointCollectionClasses } = useGetKeypointCollectionClassesQuery();
  const { data: segmentationClasses } = useGetSegmentationClassesQuery();

  const { setClassData } = useContext(ClassDataContext);

  useEffect(() => {
    if (viewClasses && phaseClasses && keyPointCollectionClasses && segmentationClasses) {
      const classData: IClassData = {
        viewClasses: viewClasses as IViewClass[],
        phaseClasses: phaseClasses as IPhaseClass[],
        keypointCollectionClasses: keyPointCollectionClasses as IKeypointClass[],
        segmentationClasses: segmentationClasses as ISegmentationClass[],
      };
      setClassData(classData);
    }
  }, [viewClasses, phaseClasses, keyPointCollectionClasses, segmentationClasses]);

  return (
    <StyleSheetManager shouldForwardProp={prop => isPropValid(prop)}>
      <BrowserRouter basename={'/'}>
        <ICardio />
        <ToastContainer position="top-right" theme="colored" />
      </BrowserRouter>
    </StyleSheetManager>
  );
}

export default App;
